/*eslint-disable*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class HeaderItems extends Component {

    render() {

        return (

            <div className="col-sm-4">
                <Link className={`small ${this.props.styleClass}`} to="#" onClick={() => this.props.handleRedirect(this.props.altName)}>
                    <img src={this.props.imgLink} width={this.props.altName == 'marketPlace' ? "59" : "35"} alt={this.props.altName} />
                    <p className="mt-2 small w3-text-black">{this.props.items}</p>
                </Link>
            </div>

        )
    }
}
export default HeaderItems